import differenceDatesInSeconds from '../date/differenceDatesInSeconds'

const setLoggedInCookie = (value, expiresIn = Date.now()) =>
(document.cookie = `loggedIn=${value}; expires=${expiresIn}; path=/ ; max-age=${differenceDatesInSeconds(
	new Date(),
	new Date(expiresIn)
)}`)

export default setLoggedInCookie